/* eslint-disable no-unused-vars */
import React, {
  useEffect,
  useContext,
  createContext,
  useState,
  useCallback,
} from "react";
import { isEqual, isFunction } from "lodash";
import { useHistory } from "react-router-dom";
// import { initialFilter } from "./SpecificationsUIHelper";

const SpecificationsUIContext = createContext();

export function useSpecificationsUIContext() {
  return useContext(SpecificationsUIContext);
}

export const SpecificationsUIConsumer = SpecificationsUIContext.Consumer;

export function SpecificationsUIProvider({
  currentParentId,
  currentParentName,
  secondId,
  secondName,
  thirdId,
  thirdName,
  initSpecification,
  children
}) {//,initialFilter
  const [parentId, setParentId] = useState(currentParentId);
  const [parentName, setParentName] = useState(currentParentName);
  const [secondParentId, setSecondParentId] = useState(secondId);
  const [secondParentName, setSecondParentName] = useState(secondName);
  const [thirdParentId, setThirdParentId] = useState(thirdId);
  const [thirdParentName, setThirdParentName] = useState(thirdName);
  const [ids, setIds] = useState([]);
  const [selectedId, setSelectedId] = useState(null);
  const [secondList, setSecondList] = useState([]);

  useEffect(() => {
    initSpecification[currentParentName] = currentParentId;
    //initSpecification.groupId = currentParentId;
    setParentId(currentParentId);
    setParentName(currentParentName);
    if (secondName) {
      initSpecification[secondName] = secondId;
      setSecondParentId(secondId);
      setSecondParentName(secondName);
      initSpecification[thirdName] = thirdId;
      setThirdParentId(thirdId);
      setThirdParentName(thirdName);
    }

  }, [currentParentId]);
  const [
    showEditSpecificationDialog,
    setShowEditSpecificationDialog,
  ] = useState(false);
  const openNewSpecificationDialog = () => {
    setSelectedId(undefined);
    setShowEditSpecificationDialog(true);
  };


  const openEditSpecificationDialog = (id) => {
    setSelectedId(id);
    setShowEditSpecificationDialog(true);
  };
  const closeEditSpecificationDialog = () => {
    setSelectedId(undefined);
    setShowEditSpecificationDialog(false);
  };
  const [
    showDeleteSpecificationDialog,
    setShowDeleteSpecificationDialog,
  ] = useState(false);

  const openDeleteSpecificationDialog = (id) => {
    setSelectedId(id);
    setShowDeleteSpecificationDialog(true);
  };
  const closeDeleteSpecificationDialog = () => {
    setSelectedId(undefined);
    setShowDeleteSpecificationDialog(false);
  };

  const [
    showRecoverDeleteSpecificationDialog,
    setShowRecoverDeleteSpecificationDialog,
  ] = useState(false);
  const openRecoverDeleteSpecificationDialog = (id) => {
    setSelectedId(id);
    setShowRecoverDeleteSpecificationDialog(true);
  };
  const closeRecoverDeleteSpecificationDialog = () => {
    setSelectedId(undefined);
    setShowRecoverDeleteSpecificationDialog(false);
  };


  const [
    showDeleteSpecificationsDialog,
    setShowDeleteSpecificationsDialog,
  ] = useState(false);
  const openDeleteSpecificationsDialog = () => {
    setShowDeleteSpecificationsDialog(true);
  };
  const closeDeleteSpecificationsDialog = () => {
    setShowDeleteSpecificationsDialog(false);
  };
  const [
    showFetchSpecificationsDialog,
    setShowFetchSpecificationsDialog,
  ] = useState(false);
  const openFetchSpecificationsDialog = () => {
    setShowFetchSpecificationsDialog(true);
  };
  const closeFetchSpecificationsDialog = () => {
    setShowFetchSpecificationsDialog(false);
  };

  const [
    showHolidaySpecificationsDialog,
    setShowHolidaySpecificationsDialog,
  ] = useState(false);
  const openHolidaySpecificationsDialog = () => {
    setShowHolidaySpecificationsDialog(true);
  };
  const closeHolidaySpecificationsDialog = () => {
    setShowHolidaySpecificationsDialog(false);
  };

  const [
    showAuditOptionSpecificationsDialog,
    setShowAuditOptionSpecificationsDialog,
  ] = useState(false);
  const openAuditOptionSpecificationsDialog = () => {
    setShowAuditOptionSpecificationsDialog(true);
  };
  const closeAuditOptionSpecificationsDialog = () => {
    setShowAuditOptionSpecificationsDialog(false);
  };

  const [
    showHardDeleteSpecificationsDialog,
    setShowHardDeleteSpecificationsDialog,
  ] = useState(false);
  const openHardDeleteSpecificationsDialog = () => {
    setShowHardDeleteSpecificationsDialog(true);
  };
  const closeHardDeleteSpecificationsDialog = () => {
    setShowHardDeleteSpecificationsDialog(false);
  };

  const [
    showRoomsDialog,
    setShowRoomsDialog,
  ] = useState(false);

  const openRoomsDialog = (id) => {
    setSelectedId(id);
    setShowRoomsDialog(true);
  };
  const closeRoomsDialog = () => {
    setShowRoomsDialog(false);
  };


  const value = {
    ids,
    setIds,
    parentId,
    setParentId,
    parentName,
    setParentName,
    secondParentId,
    setSecondParentId,
    secondParentName,
    setSecondParentName,
    secondList,
    setSecondList,
    initSpecification,
    selectedId,
    showEditSpecificationDialog,
    openEditSpecificationDialog,
    openNewSpecificationDialog,
    closeEditSpecificationDialog,
    showDeleteSpecificationDialog,
    openDeleteSpecificationDialog,
    closeDeleteSpecificationDialog,
    showRecoverDeleteSpecificationDialog,
    openRecoverDeleteSpecificationDialog,
    closeRecoverDeleteSpecificationDialog,
    showDeleteSpecificationsDialog,
    openDeleteSpecificationsDialog,
    closeDeleteSpecificationsDialog,
    showFetchSpecificationsDialog,
    openFetchSpecificationsDialog,
    closeFetchSpecificationsDialog,
    showHolidaySpecificationsDialog,
    openHolidaySpecificationsDialog,
    closeHolidaySpecificationsDialog,
    showAuditOptionSpecificationsDialog,
    openAuditOptionSpecificationsDialog,
    closeAuditOptionSpecificationsDialog,
    showHardDeleteSpecificationsDialog,
    openHardDeleteSpecificationsDialog,
    closeHardDeleteSpecificationsDialog,
    showRoomsDialog,
    openRoomsDialog,
    closeRoomsDialog
  };

  return (
    <SpecificationsUIContext.Provider value={value}>
      {children}
    </SpecificationsUIContext.Provider>
  );
}
